<template>
  <teleport to="#home-body">
    <EditPopup
      v-for="(item, index) of dataList"
      :key="item"
      title="线索区分析"
      :controls="controls"
      :target="item"
      class="shoot-data-view-info-popup"
      :titleDrag="true"
      :style="{
        '--top': index * 20 + 'px',
        '--left': index * 20 + 'px',
      }"
    >
      <DataInfo
        :target="item"
      ></DataInfo>
    </EditPopup>
  </teleport>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, toRaw,
} from 'vue';
import { isNull, dayjs, message, vueCreateAppInit, } from '@/utils/js/initVariable';
import store from '@/store';
import { jsonStyleInit } from '@/utils/js/leaflet';

import {
  getGlobalExposureDataByPermissionRegionToday, getPolygonClueArea,
} from '@/api/Region';

import CustomLocaleControl from '@/views/Home/component/ManagePanel/components/WorkSpace/components/WorkSpaceData/components/CustomLocaleControl';
import EditPopup from '@/views/Home/component/ManagePanel/components/WorkSpace/components/WorkSpaceData/components/CustomLocaleControl/components/EditPopup';
import DataInfo from './DataInfo';

// 定义：热点中心标记（svg-sprite 引用，红色底+白色火焰已合并在 SVG 内）
const hotspotMarkerIcon = L.divIcon({
  className: 'hotspot-center-marker',
  html: `
    <svg class="hotspot-marker-fire" width="24" height="24">
      <use href="#icon-hotspot-fire"></use>
    </svg>
  `,
  iconSize: [24, 24],
  iconAnchor: [12, 12],
  popupAnchor: [0, -12],
});

// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);


const homeMap = computed(()=> store.getters['getHomeMap'] ),
      map = toRaw(homeMap.value),
      layerGroup = L.featureGroup(),
      layerGroupClose = ()=>{
        map.removeLayer(layerGroup);
      },
      layerGroupAdd = ()=>{
        map.addLayer(layerGroup);
      }

const todayExposureShowFlag = computed(()=> store.getters['todayExposureShowFlag'] );

watch(todayExposureShowFlag, (newd, old)=>{
  if(newd){
    layerGroupAdd();
  }else{
    layerGroupClose();
  }
}, {
  immediate: true,
})


const dataClose = (target)=>{
  // console.log(target);
  dataList.value.splice(target, 1);
},
dataListPush = (target)=>{
  if(!dataList.value.includes(target)){
    dataList.value.push(target);
  }
}

const dataList = ref([]), controls = ref([
  { iconName: 'close-box', fill: 'rgb(6, 180, 221)', onClick: dataClose, }
])

const fillIds = [ 3, 4, 8 ], defaultFillIds = [ 5 ];
const getTypeText = (name, fill)=>{
  return name?`<p style="color:${fill}">${ name }</p>`:'';
}

let idsCall, idsCallClear = (idsCall)=>{
  idsCall && cancelIdleCallback(idsCall);
}

const exposureNoShowList = computed(()=> store.getters['exposureNoShowList']);

const exposureMap = new Map(), hotspotMap = new Map(),
      /**
       * type: 区域类型 fill: 区域颜色 dataType: 数据类型(undefined/hots)
       * 注: 数据类型的undefined是线索区
       */
      exposureMapGroupInit = (type, fill, dataType)=>{
        if(dataType == 'hots'){
          if(hotspotMap.get(type)){
            return hotspotMap.get(type);
          }
        }else if(exposureMap.has(type)){
          return exposureMap.get(type);
        }
        
        const group = L.featureGroup();
        (!exposureNoShowList.value.includes(type)) && layerGroup.addLayer(group);
        if(dataType == 'hots'){
          hotspotMap.set(type, group);
        }else{
          exposureMap.set(type, group);
        }
        /**
         * v1.0 list版本同一区域类型 只能对应单一数据类型
         */
        // store.commit('todayExposureLegendListAdd', {
        //   type, color: fill, 
        //   controls: [
        //     {
        //       fn: (flag)=>{
        //         if(flag){
        //           layerGroup.addLayer(group);
        //         }else{
        //           layerGroup.removeLayer(group);
        //         }
        //       }
        //     },
        //   ]
        // });
        /**
         * v2.0 同一区域类型 只能对应多数据类型
         */
        const map = store.getters['todayExposureLegendMap']
        const controlItem = {
          group: group, color: fill, fn: (flag)=>{
            if(flag){
              layerGroup.addLayer(group);
            }else{
              layerGroup.removeLayer(group);
            }
          },
        }
        if(!map.has(type)){
          store.commit('todayExposureLegendMapSet', {
            type, item: [ controlItem ]
          })
        }else{
          const controls = map.get(type);
          controls && controls.push(controlItem);
          store.commit('todayExposureLegendMapUpdate');
        }
        return group;
      }
const getExposureFill = (item)=>{
  if(fillIds.includes(item['polygonTypeShowId'])){
    return 'rgb(206 28 13)';
  }else if(defaultFillIds.includes(item['polygonTypeShowId'])){
    return undefined;
  }else if(item['polygonTypeShowId']){
    return 'rgb(242, 186, 44)';
  }
}
const exposureDataInit = (data)=>{
  // console.log(data);
  store.commit('clueAreaListInner', data);
  data.forEach(item=>{
    exposureMapGroupInit(item['polygonTypeShowName'] || '线索区', getExposureFill(item));
  });
  // const group = L.featureGroup().addTo(layerGroup);
  const layerInit = (item)=>{
    let fill = getExposureFill(item);
    const group = exposureMapGroupInit(item['polygonTypeShowName'] || '线索区', fill);
    
    const text = `
      ${ getTypeText(item['polygonTypeShowName'], fill) }
      <p style="color:${fill}">${ dayjs(item['scanProductTime']).format('YYYY-MM-DD HH:mm:ss') }</p>
    `;
    const json = JSON.parse(item['scanSatellitePolygon']);
    // 处理区域样式
    jsonStyleInit(json, { fill, });

    let layer;
    L.geoJSON(json, {
      onEachFeature: (feature, l)=>{
        layer = l;
      },
    });
    layer.bindTooltip(text, {
      // offset: [0, 40],
      sticky: true,
      className: "leaflet-tooltip-message",
      direction: 'top',
      // maxWidth: 300,
      // maxHeight: 20,
      // permanent: true,
    }).on({
      dblclick: (e)=>{
        L.DomEvent.stop(e);
        // getAirBaseByRegionFn(item);
        dataListPush(item);
      },
    }).once({
      click: event=>{
        customLocaleControlInit(layer, {  }, group);
      }
    }).addTo(group);
    item['layer'] = layer;
  }
  let i = 0;
  const requestIdleCallbackFn = (deadline)=>{
    while (deadline.timeRemaining() > 0 && data.length > i) {
      const item = data.at(i++);
      layerInit(item);
    }
    if(i == data.length){
      // group.addTo(layerGroup);
      idsCallClear(idsCall);
    }else{
      idsCallClear(idsCall);
      idsCall = requestIdleCallback(requestIdleCallbackFn);
    }
  }
  idsCallClear(idsCall);
  idsCall = requestIdleCallback(requestIdleCallbackFn);
}

const customLocaleControlInit = (layer, target, group)=>{
  // console.log(layer);
  const bounds = layer.getBounds();
  const layerClick = (event)=>{
    const icon = controlMarker && controlMarker._icon;
    if(!icon)return;
    const display = icon.style.display;
    if(display == 'none'){
      icon.style.display = 'unset';
    }else{
      icon.style.display = 'none';
    }
  }
  const app = vueCreateAppInit(CustomLocaleControl, {
    target,
    layer,
    onLayerDelete: ()=>{
      group.removeLayer(layer);
      controlMarker && group.removeLayer(controlMarker);
    },
    layerGroup: group,
    // workSpace: props.workSpace,
    layerClick,
  });
  const div = document.createElement('div');
  app.mount(div);

  const controlMarker = L.marker(bounds.getNorthEast(),{
    icon: L.divIcon({
      iconAnchor: [-5, 0],
      html: div,
    }),
    // interactive: false,
  }).on({
    remove: event=>{
      app.unmount();
    },
  }).addTo(group);

}

const getGlobalExposureDataByPermissionRegionTodayFn = ()=>{
  getGlobalExposureDataByPermissionRegionToday({}).then(res=>{
    if(res.data.code == 1004){
      const list = res.data.dataList || (res.data.data && res.data.data.dataList) || [];
      const hotspot = res.data.hotspotData || (res.data.data && res.data.data.hotspotData);
      exposureDataInit(list);
      if(hotspot) {
        hotspotDataInit(hotspot);
      }
    }
  }).catch(err=>{
    console.log(err);
  });
}
let controller, controllerClear = ()=>{
  controller && controller.abort();
}

const hotspotDataInit = (hotspotData) => {
  for (const categoryName in hotspotData) {
    const hotspotList = hotspotData[categoryName];
    if (!hotspotList || hotspotList.length === 0) continue;
    
    // 获取当前分类对应的 group，如果不存在会新建并注册图例
    const group = exposureMapGroupInit(categoryName, '#00ff00', 'hots');

    if (!map.getPane('hotspotPane')) {
      map.createPane('hotspotPane');
      map.getPane('hotspotPane').style.zIndex = 450;
    }

    hotspotList.forEach(hotspot => {
      if (hotspot.geoJson) {
        const polygonLayer = L.geoJSON(hotspot.geoJson, {
          pane: 'hotspotPane',
          style: {
            color: "#00ff00",
            dashArray: "5, 5",
            // fill: false,
            opacity: 1,
            weight: 3
          },
          onEachFeature: (feature, layer) => {
            layer.setStyle({
              color: "#00ff00",
              dashArray: "5, 5",
              // fill: false,
              fillOpacity: 0,
              opacity: 1,
              weight: 3
            });
          }
        });
        
        polygonLayer.bindTooltip(`
          <div>
            <b>${hotspot.hotspotName || '热点区域'} ${ categoryName }</b><br/>
            包含多边形数: ${hotspot.polygonCount || 0}<br/>
            面积: ${hotspot.areaSize || 0} km²<br/>
            中心: (${hotspot.centerLng?.toFixed(3)}, ${hotspot.centerLat?.toFixed(3)})
          </div>
        `, { sticky: true, className: "leaflet-tooltip-message" });
        
        polygonLayer.addTo(group);

        if (hotspot.centerLat && hotspot.centerLng) {
          L.marker([hotspot.centerLat, hotspot.centerLng], {
            icon: hotspotMarkerIcon
          }).on({
            click: event=>{
              polygonLayer && map.fitBounds(
                polygonLayer.getBounds()
              );
            }
          }).addTo(group);
        }
      }
    });
  }
}
const getPolygonClueAreaFn = ()=>{
  controllerClear();
  controller = new AbortController();
  getPolygonClueArea({
    controllerSignal: controller.signal,
  }).then(res=>{
    if(res.data.code == 1004){
      const list = res.data.dataList || (res.data.data && res.data.data.dataList) || [];
      const hotspot = res.data.hotspotData || (res.data.data && res.data.data.hotspotData);
      exposureDataInit(list);
      if(hotspot) {
        hotspotDataInit(hotspot);
      }
    }
  }).catch(err=>{
    console.log(err);
  });
}

const init = ()=>{
  getPolygonClueAreaFn();
  // getGlobalExposureDataByPermissionRegionTodayFn();
}

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  init();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  layerGroupClose();
  store.commit('clueAreaListClear');
  store.commit('todayExposureLegendListClear');
  store.commit('todayExposureLegendMapClear');
  idsCallClear(idsCall);
  controllerClear();
});

</script>

<style lang='less'>
/* 热点中心标记 */
.hotspot-center-marker .hotspot-marker-fire {
  display: block;
}
</style>

<style lang='less' scoped>
.shoot-data-view-info-popup{
  position: absolute;
  top: calc(10px + var(--top));
  left: calc(var(--nav-panel-width) + 20px + var(--left));
  transition: left var(--nav-collapsed-duration) ease;
}
</style>
